export function objectHasProperty(obj, property: string) {
  if (obj && Object.prototype.hasOwnProperty.call(obj, property)) {
    return true;
  }
  return false;
}
